import React, { FunctionComponent } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { Select } from 'core/select/Select';
import { RelationshipStatus } from 'social/publisher/Publisher.types';

interface Props {
    relationshipStatuses: RelationshipStatus[] | undefined;
    save: any;
}
type Option = {
    value: RelationshipStatus;
    label: string;
};
const RELATIONSHIP_STATUS_OPTIONS: Option[] = [
    { label: 'SINGLE', value: RelationshipStatus.SINGLE },
    { label: 'IN_A_RELATIONSHIP', value: RelationshipStatus.IN_RELATIONSHIP },
    { label: 'MARRIED', value: RelationshipStatus.MARRIED },
    { label: 'ENGAGED', value: RelationshipStatus.ENGAGED },
];

export const RelationshipStatusField: FunctionComponent<Props> = ({ relationshipStatuses, save }) => {
    const { t } = useTranslation(['social/publisher']);
    const options = RELATIONSHIP_STATUS_OPTIONS.map((el) => {
        return { value: el.value, label: t(el.label) };
    });
    let selectedOptions: Option[] = [];

    if (relationshipStatuses && relationshipStatuses.length > 0) {
        selectedOptions = _.filter(options, (el) => _.includes(relationshipStatuses, el.value));
    }

    const hanldeRelationshiopStatusChange = (selectedOptions: Option[]): void => {
        let newEducationalStatuses: RelationshipStatus[] = [];

        if (selectedOptions && selectedOptions.length > 0) {
            newEducationalStatuses = selectedOptions.map((el) => el.value);
        }
        save(newEducationalStatuses);
    };

    return (
        <Select
            name="relationship-status"
            className="relationship-status-select"
            classNamePrefix="audience-targeting-relationship-status"
            options={options}
            value={selectedOptions}
            onChange={hanldeRelationshiopStatusChange}
            isMulti
            placeholder={t('SELECT')}
        />
    );
};
